import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { authApi } from '@/services';
import type { TUser } from '@/services/auth/auth.types.ts';

export const useLogout = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: authApi.logout,
    onSuccess: () => {
      message.success('Logged out successfully');
      queryClient.clear();
      navigate('/public/login');
    },
  });
};

export const userInitials = (user?: TUser) =>
  `${user?.first_name?.[0] ?? ''}${user?.last_name?.[0] ?? ''}`.toUpperCase();

export const userFullName = (user?: TUser) =>
  [user?.first_name, user?.last_name].filter(Boolean).join(' ');

export const roleLabel = (role?: string) =>
  role ? role.charAt(0) + role.slice(1).toLowerCase() : '';
